import { Node, nodePasteRule, mergeAttributes, Extension, Mark, markPasteRule } from "@tiptap/core";
import { Plugin, PluginKey } from "prosemirror-state";
import { readServerConfig, uploadFile } from "nostr-tools/nip96";
import { getToken } from "nostr-tools/nip98";
import { Image } from "@tiptap/extension-image";
import { defaultMarkdownSerializer } from "prosemirror-markdown";
import { Link } from "@tiptap/extension-link";
import * as linkifyjs from "linkifyjs";
import { decode as decode$1 } from "nostr-tools/nip19";
var lib = {};
(function(exports) {
  /*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  Object.defineProperty(exports, "__esModule", { value: true });
  exports.bytes = exports.stringToBytes = exports.str = exports.bytesToString = exports.hex = exports.utf8 = exports.bech32m = exports.bech32 = exports.base58check = exports.base58xmr = exports.base58xrp = exports.base58flickr = exports.base58 = exports.base64url = exports.base64 = exports.base32crockford = exports.base32hex = exports.base32 = exports.base16 = exports.utils = exports.assertNumber = void 0;
  function assertNumber(n) {
    if (!Number.isSafeInteger(n))
      throw new Error(`Wrong integer: ${n}`);
  }
  exports.assertNumber = assertNumber;
  function chain(...args) {
    const wrap = (a, b) => (c) => a(b(c));
    const encode = Array.from(args).reverse().reduce((acc, i) => acc ? wrap(acc, i.encode) : i.encode, void 0);
    const decode2 = args.reduce((acc, i) => acc ? wrap(acc, i.decode) : i.decode, void 0);
    return { encode, decode: decode2 };
  }
  function alphabet(alphabet2) {
    return {
      encode: (digits) => {
        if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number")
          throw new Error("alphabet.encode input should be an array of numbers");
        return digits.map((i) => {
          assertNumber(i);
          if (i < 0 || i >= alphabet2.length)
            throw new Error(`Digit index outside alphabet: ${i} (alphabet: ${alphabet2.length})`);
          return alphabet2[i];
        });
      },
      decode: (input) => {
        if (!Array.isArray(input) || input.length && typeof input[0] !== "string")
          throw new Error("alphabet.decode input should be array of strings");
        return input.map((letter) => {
          if (typeof letter !== "string")
            throw new Error(`alphabet.decode: not string element=${letter}`);
          const index = alphabet2.indexOf(letter);
          if (index === -1)
            throw new Error(`Unknown letter: "${letter}". Allowed: ${alphabet2}`);
          return index;
        });
      }
    };
  }
  function join(separator = "") {
    if (typeof separator !== "string")
      throw new Error("join separator should be string");
    return {
      encode: (from) => {
        if (!Array.isArray(from) || from.length && typeof from[0] !== "string")
          throw new Error("join.encode input should be array of strings");
        for (let i of from)
          if (typeof i !== "string")
            throw new Error(`join.encode: non-string input=${i}`);
        return from.join(separator);
      },
      decode: (to) => {
        if (typeof to !== "string")
          throw new Error("join.decode input should be string");
        return to.split(separator);
      }
    };
  }
  function padding(bits, chr = "=") {
    assertNumber(bits);
    if (typeof chr !== "string")
      throw new Error("padding chr should be string");
    return {
      encode(data) {
        if (!Array.isArray(data) || data.length && typeof data[0] !== "string")
          throw new Error("padding.encode input should be array of strings");
        for (let i of data)
          if (typeof i !== "string")
            throw new Error(`padding.encode: non-string input=${i}`);
        while (data.length * bits % 8)
          data.push(chr);
        return data;
      },
      decode(input) {
        if (!Array.isArray(input) || input.length && typeof input[0] !== "string")
          throw new Error("padding.encode input should be array of strings");
        for (let i of input)
          if (typeof i !== "string")
            throw new Error(`padding.decode: non-string input=${i}`);
        let end = input.length;
        if (end * bits % 8)
          throw new Error("Invalid padding: string should have whole number of bytes");
        for (; end > 0 && input[end - 1] === chr; end--) {
          if (!((end - 1) * bits % 8))
            throw new Error("Invalid padding: string has too much padding");
        }
        return input.slice(0, end);
      }
    };
  }
  function normalize(fn) {
    if (typeof fn !== "function")
      throw new Error("normalize fn should be function");
    return { encode: (from) => from, decode: (to) => fn(to) };
  }
  function convertRadix(data, from, to) {
    if (from < 2)
      throw new Error(`convertRadix: wrong from=${from}, base cannot be less than 2`);
    if (to < 2)
      throw new Error(`convertRadix: wrong to=${to}, base cannot be less than 2`);
    if (!Array.isArray(data))
      throw new Error("convertRadix: data should be array");
    if (!data.length)
      return [];
    let pos = 0;
    const res = [];
    const digits = Array.from(data);
    digits.forEach((d) => {
      assertNumber(d);
      if (d < 0 || d >= from)
        throw new Error(`Wrong integer: ${d}`);
    });
    while (true) {
      let carry = 0;
      let done = true;
      for (let i = pos; i < digits.length; i++) {
        const digit = digits[i];
        const digitBase = from * carry + digit;
        if (!Number.isSafeInteger(digitBase) || from * carry / from !== carry || digitBase - digit !== from * carry) {
          throw new Error("convertRadix: carry overflow");
        }
        carry = digitBase % to;
        digits[i] = Math.floor(digitBase / to);
        if (!Number.isSafeInteger(digits[i]) || digits[i] * to + carry !== digitBase)
          throw new Error("convertRadix: carry overflow");
        if (!done)
          continue;
        else if (!digits[i])
          pos = i;
        else
          done = false;
      }
      res.push(carry);
      if (done)
        break;
    }
    for (let i = 0; i < data.length - 1 && data[i] === 0; i++)
      res.push(0);
    return res.reverse();
  }
  const gcd = (a, b) => !b ? a : gcd(b, a % b);
  const radix2carry = (from, to) => from + (to - gcd(from, to));
  function convertRadix2(data, from, to, padding2) {
    if (!Array.isArray(data))
      throw new Error("convertRadix2: data should be array");
    if (from <= 0 || from > 32)
      throw new Error(`convertRadix2: wrong from=${from}`);
    if (to <= 0 || to > 32)
      throw new Error(`convertRadix2: wrong to=${to}`);
    if (radix2carry(from, to) > 32) {
      throw new Error(`convertRadix2: carry overflow from=${from} to=${to} carryBits=${radix2carry(from, to)}`);
    }
    let carry = 0;
    let pos = 0;
    const mask = 2 ** to - 1;
    const res = [];
    for (const n of data) {
      assertNumber(n);
      if (n >= 2 ** from)
        throw new Error(`convertRadix2: invalid data word=${n} from=${from}`);
      carry = carry << from | n;
      if (pos + from > 32)
        throw new Error(`convertRadix2: carry overflow pos=${pos} from=${from}`);
      pos += from;
      for (; pos >= to; pos -= to)
        res.push((carry >> pos - to & mask) >>> 0);
      carry &= 2 ** pos - 1;
    }
    carry = carry << to - pos & mask;
    if (!padding2 && pos >= from)
      throw new Error("Excess padding");
    if (!padding2 && carry)
      throw new Error(`Non-zero padding: ${carry}`);
    if (padding2 && pos > 0)
      res.push(carry >>> 0);
    return res;
  }
  function radix(num) {
    assertNumber(num);
    return {
      encode: (bytes) => {
        if (!(bytes instanceof Uint8Array))
          throw new Error("radix.encode input should be Uint8Array");
        return convertRadix(Array.from(bytes), 2 ** 8, num);
      },
      decode: (digits) => {
        if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number")
          throw new Error("radix.decode input should be array of strings");
        return Uint8Array.from(convertRadix(digits, num, 2 ** 8));
      }
    };
  }
  function radix2(bits, revPadding = false) {
    assertNumber(bits);
    if (bits <= 0 || bits > 32)
      throw new Error("radix2: bits should be in (0..32]");
    if (radix2carry(8, bits) > 32 || radix2carry(bits, 8) > 32)
      throw new Error("radix2: carry overflow");
    return {
      encode: (bytes) => {
        if (!(bytes instanceof Uint8Array))
          throw new Error("radix2.encode input should be Uint8Array");
        return convertRadix2(Array.from(bytes), 8, bits, !revPadding);
      },
      decode: (digits) => {
        if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number")
          throw new Error("radix2.decode input should be array of strings");
        return Uint8Array.from(convertRadix2(digits, bits, 8, revPadding));
      }
    };
  }
  function unsafeWrapper(fn) {
    if (typeof fn !== "function")
      throw new Error("unsafeWrapper fn should be function");
    return function(...args) {
      try {
        return fn.apply(null, args);
      } catch (e) {
      }
    };
  }
  function checksum(len, fn) {
    assertNumber(len);
    if (typeof fn !== "function")
      throw new Error("checksum fn should be function");
    return {
      encode(data) {
        if (!(data instanceof Uint8Array))
          throw new Error("checksum.encode: input should be Uint8Array");
        const checksum2 = fn(data).slice(0, len);
        const res = new Uint8Array(data.length + len);
        res.set(data);
        res.set(checksum2, data.length);
        return res;
      },
      decode(data) {
        if (!(data instanceof Uint8Array))
          throw new Error("checksum.decode: input should be Uint8Array");
        const payload = data.slice(0, -len);
        const newChecksum = fn(payload).slice(0, len);
        const oldChecksum = data.slice(-len);
        for (let i = 0; i < len; i++)
          if (newChecksum[i] !== oldChecksum[i])
            throw new Error("Invalid checksum");
        return payload;
      }
    };
  }
  exports.utils = { alphabet, chain, checksum, radix, radix2, join, padding };
  exports.base16 = chain(radix2(4), alphabet("0123456789ABCDEF"), join(""));
  exports.base32 = chain(radix2(5), alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), padding(5), join(""));
  exports.base32hex = chain(radix2(5), alphabet("0123456789ABCDEFGHIJKLMNOPQRSTUV"), padding(5), join(""));
  exports.base32crockford = chain(radix2(5), alphabet("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), join(""), normalize((s) => s.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1")));
  exports.base64 = chain(radix2(6), alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), padding(6), join(""));
  exports.base64url = chain(radix2(6), alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), padding(6), join(""));
  const genBase58 = (abc) => chain(radix(58), alphabet(abc), join(""));
  exports.base58 = genBase58("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
  exports.base58flickr = genBase58("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ");
  exports.base58xrp = genBase58("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
  const XMR_BLOCK_LEN = [0, 2, 3, 5, 6, 7, 9, 10, 11];
  exports.base58xmr = {
    encode(data) {
      let res = "";
      for (let i = 0; i < data.length; i += 8) {
        const block = data.subarray(i, i + 8);
        res += exports.base58.encode(block).padStart(XMR_BLOCK_LEN[block.length], "1");
      }
      return res;
    },
    decode(str) {
      let res = [];
      for (let i = 0; i < str.length; i += 11) {
        const slice = str.slice(i, i + 11);
        const blockLen = XMR_BLOCK_LEN.indexOf(slice.length);
        const block = exports.base58.decode(slice);
        for (let j = 0; j < block.length - blockLen; j++) {
          if (block[j] !== 0)
            throw new Error("base58xmr: wrong padding");
        }
        res = res.concat(Array.from(block.slice(block.length - blockLen)));
      }
      return Uint8Array.from(res);
    }
  };
  const base58check = (sha256) => chain(checksum(4, (data) => sha256(sha256(data))), exports.base58);
  exports.base58check = base58check;
  const BECH_ALPHABET = chain(alphabet("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), join(""));
  const POLYMOD_GENERATORS = [996825010, 642813549, 513874426, 1027748829, 705979059];
  function bech32Polymod(pre) {
    const b = pre >> 25;
    let chk = (pre & 33554431) << 5;
    for (let i = 0; i < POLYMOD_GENERATORS.length; i++) {
      if ((b >> i & 1) === 1)
        chk ^= POLYMOD_GENERATORS[i];
    }
    return chk;
  }
  function bechChecksum(prefix, words, encodingConst = 1) {
    const len = prefix.length;
    let chk = 1;
    for (let i = 0; i < len; i++) {
      const c = prefix.charCodeAt(i);
      if (c < 33 || c > 126)
        throw new Error(`Invalid prefix (${prefix})`);
      chk = bech32Polymod(chk) ^ c >> 5;
    }
    chk = bech32Polymod(chk);
    for (let i = 0; i < len; i++)
      chk = bech32Polymod(chk) ^ prefix.charCodeAt(i) & 31;
    for (let v of words)
      chk = bech32Polymod(chk) ^ v;
    for (let i = 0; i < 6; i++)
      chk = bech32Polymod(chk);
    chk ^= encodingConst;
    return BECH_ALPHABET.encode(convertRadix2([chk % 2 ** 30], 30, 5, false));
  }
  function genBech32(encoding) {
    const ENCODING_CONST = encoding === "bech32" ? 1 : 734539939;
    const _words = radix2(5);
    const fromWords = _words.decode;
    const toWords = _words.encode;
    const fromWordsUnsafe = unsafeWrapper(fromWords);
    function encode(prefix, words, limit = 90) {
      if (typeof prefix !== "string")
        throw new Error(`bech32.encode prefix should be string, not ${typeof prefix}`);
      if (!Array.isArray(words) || words.length && typeof words[0] !== "number")
        throw new Error(`bech32.encode words should be array of numbers, not ${typeof words}`);
      const actualLength = prefix.length + 7 + words.length;
      if (limit !== false && actualLength > limit)
        throw new TypeError(`Length ${actualLength} exceeds limit ${limit}`);
      prefix = prefix.toLowerCase();
      return `${prefix}1${BECH_ALPHABET.encode(words)}${bechChecksum(prefix, words, ENCODING_CONST)}`;
    }
    function decode2(str, limit = 90) {
      if (typeof str !== "string")
        throw new Error(`bech32.decode input should be string, not ${typeof str}`);
      if (str.length < 8 || limit !== false && str.length > limit)
        throw new TypeError(`Wrong string length: ${str.length} (${str}). Expected (8..${limit})`);
      const lowered = str.toLowerCase();
      if (str !== lowered && str !== str.toUpperCase())
        throw new Error(`String must be lowercase or uppercase`);
      str = lowered;
      const sepIndex = str.lastIndexOf("1");
      if (sepIndex === 0 || sepIndex === -1)
        throw new Error(`Letter "1" must be present between prefix and data only`);
      const prefix = str.slice(0, sepIndex);
      const _words2 = str.slice(sepIndex + 1);
      if (_words2.length < 6)
        throw new Error("Data must be at least 6 characters long");
      const words = BECH_ALPHABET.decode(_words2).slice(0, -6);
      const sum = bechChecksum(prefix, words, ENCODING_CONST);
      if (!_words2.endsWith(sum))
        throw new Error(`Invalid checksum in ${str}: expected "${sum}"`);
      return { prefix, words };
    }
    const decodeUnsafe = unsafeWrapper(decode2);
    function decodeToBytes(str) {
      const { prefix, words } = decode2(str, false);
      return { prefix, words, bytes: fromWords(words) };
    }
    return { encode, decode: decode2, decodeToBytes, decodeUnsafe, fromWords, fromWordsUnsafe, toWords };
  }
  exports.bech32 = genBech32("bech32");
  exports.bech32m = genBech32("bech32m");
  exports.utf8 = {
    encode: (data) => new TextDecoder().decode(data),
    decode: (str) => new TextEncoder().encode(str)
  };
  exports.hex = chain(radix2(4), alphabet("0123456789abcdef"), join(""), normalize((s) => {
    if (typeof s !== "string" || s.length % 2)
      throw new TypeError(`hex.decode: expected string, got ${typeof s} with length ${s.length}`);
    return s.toLowerCase();
  }));
  const CODERS = {
    utf8: exports.utf8,
    hex: exports.hex,
    base16: exports.base16,
    base32: exports.base32,
    base64: exports.base64,
    base64url: exports.base64url,
    base58: exports.base58,
    base58xmr: exports.base58xmr
  };
  const coderTypeError = `Invalid encoding type. Available types: ${Object.keys(CODERS).join(", ")}`;
  const bytesToString = (type, bytes) => {
    if (typeof type !== "string" || !CODERS.hasOwnProperty(type))
      throw new TypeError(coderTypeError);
    if (!(bytes instanceof Uint8Array))
      throw new TypeError("bytesToString() expects Uint8Array");
    return CODERS[type].encode(bytes);
  };
  exports.bytesToString = bytesToString;
  exports.str = exports.bytesToString;
  const stringToBytes = (type, str) => {
    if (!CODERS.hasOwnProperty(type))
      throw new TypeError(coderTypeError);
    if (typeof str !== "string")
      throw new TypeError("stringToBytes() expects string");
    return CODERS[type].decode(str);
  };
  exports.stringToBytes = stringToBytes;
  exports.bytes = exports.stringToBytes;
})(lib);
const { bech32, hex, utf8 } = lib;
const DEFAULTNETWORK = {
  // default network is bitcoin
  bech32: "bc",
  pubKeyHash: 0,
  scriptHash: 5,
  validWitnessVersions: [0]
};
const TESTNETWORK = {
  bech32: "tb",
  pubKeyHash: 111,
  scriptHash: 196,
  validWitnessVersions: [0]
};
const SIGNETNETWORK = {
  bech32: "tbs",
  pubKeyHash: 111,
  scriptHash: 196,
  validWitnessVersions: [0]
};
const REGTESTNETWORK = {
  bech32: "bcrt",
  pubKeyHash: 111,
  scriptHash: 196,
  validWitnessVersions: [0]
};
const SIMNETWORK = {
  bech32: "sb",
  pubKeyHash: 63,
  scriptHash: 123,
  validWitnessVersions: [0]
};
const FEATUREBIT_ORDER = [
  "option_data_loss_protect",
  "initial_routing_sync",
  "option_upfront_shutdown_script",
  "gossip_queries",
  "var_onion_optin",
  "gossip_queries_ex",
  "option_static_remotekey",
  "payment_secret",
  "basic_mpp",
  "option_support_large_channel"
];
const DIVISORS = {
  m: BigInt(1e3),
  u: BigInt(1e6),
  n: BigInt(1e9),
  p: BigInt(1e12)
};
const MAX_MILLISATS = BigInt("2100000000000000000");
const MILLISATS_PER_BTC = BigInt(1e11);
const TAGCODES = {
  payment_hash: 1,
  payment_secret: 16,
  description: 13,
  payee: 19,
  description_hash: 23,
  // commit to longer descriptions (used by lnurl-pay)
  expiry: 6,
  // default: 3600 (1 hour)
  min_final_cltv_expiry: 24,
  // default: 9
  fallback_address: 9,
  route_hint: 3,
  // for extra routing info (private etc.)
  feature_bits: 5,
  metadata: 27
};
const TAGNAMES = {};
for (let i = 0, keys = Object.keys(TAGCODES); i < keys.length; i++) {
  const currentName = keys[i];
  const currentCode = TAGCODES[keys[i]].toString();
  TAGNAMES[currentCode] = currentName;
}
const TAGPARSERS = {
  1: (words) => hex.encode(bech32.fromWordsUnsafe(words)),
  // 256 bits
  16: (words) => hex.encode(bech32.fromWordsUnsafe(words)),
  // 256 bits
  13: (words) => utf8.encode(bech32.fromWordsUnsafe(words)),
  // string variable length
  19: (words) => hex.encode(bech32.fromWordsUnsafe(words)),
  // 264 bits
  23: (words) => hex.encode(bech32.fromWordsUnsafe(words)),
  // 256 bits
  27: (words) => hex.encode(bech32.fromWordsUnsafe(words)),
  // variable
  6: wordsToIntBE,
  // default: 3600 (1 hour)
  24: wordsToIntBE,
  // default: 9
  3: routingInfoParser,
  // for extra routing info (private etc.)
  5: featureBitsParser
  // keep feature bits as array of 5 bit words
};
function getUnknownParser(tagCode) {
  return (words) => ({
    tagCode: parseInt(tagCode),
    words: bech32.encode("unknown", words, Number.MAX_SAFE_INTEGER)
  });
}
function wordsToIntBE(words) {
  return words.reverse().reduce((total, item, index) => {
    return total + item * Math.pow(32, index);
  }, 0);
}
function routingInfoParser(words) {
  const routes = [];
  let pubkey, shortChannelId, feeBaseMSats, feeProportionalMillionths, cltvExpiryDelta;
  let routesBuffer = bech32.fromWordsUnsafe(words);
  while (routesBuffer.length > 0) {
    pubkey = hex.encode(routesBuffer.slice(0, 33));
    shortChannelId = hex.encode(routesBuffer.slice(33, 41));
    feeBaseMSats = parseInt(hex.encode(routesBuffer.slice(41, 45)), 16);
    feeProportionalMillionths = parseInt(
      hex.encode(routesBuffer.slice(45, 49)),
      16
    );
    cltvExpiryDelta = parseInt(hex.encode(routesBuffer.slice(49, 51)), 16);
    routesBuffer = routesBuffer.slice(51);
    routes.push({
      pubkey,
      short_channel_id: shortChannelId,
      fee_base_msat: feeBaseMSats,
      fee_proportional_millionths: feeProportionalMillionths,
      cltv_expiry_delta: cltvExpiryDelta
    });
  }
  return routes;
}
function featureBitsParser(words) {
  const bools = words.slice().reverse().map((word) => [
    !!(word & 1),
    !!(word & 2),
    !!(word & 4),
    !!(word & 8),
    !!(word & 16)
  ]).reduce((finalArr, itemArr) => finalArr.concat(itemArr), []);
  while (bools.length < FEATUREBIT_ORDER.length * 2) {
    bools.push(false);
  }
  const featureBits = {};
  FEATUREBIT_ORDER.forEach((featureName, index) => {
    let status;
    if (bools[index * 2]) {
      status = "required";
    } else if (bools[index * 2 + 1]) {
      status = "supported";
    } else {
      status = "unsupported";
    }
    featureBits[featureName] = status;
  });
  const extraBits = bools.slice(FEATUREBIT_ORDER.length * 2);
  featureBits.extra_bits = {
    start_bit: FEATUREBIT_ORDER.length * 2,
    bits: extraBits,
    has_required: extraBits.reduce(
      (result, bit, index) => index % 2 !== 0 ? result || false : result || bit,
      false
    )
  };
  return featureBits;
}
function hrpToMillisat(hrpString, outputString) {
  let divisor, value;
  if (hrpString.slice(-1).match(/^[munp]$/)) {
    divisor = hrpString.slice(-1);
    value = hrpString.slice(0, -1);
  } else if (hrpString.slice(-1).match(/^[^munp0-9]$/)) {
    throw new Error("Not a valid multiplier for the amount");
  } else {
    value = hrpString;
  }
  if (!value.match(/^\d+$/))
    throw new Error("Not a valid human readable amount");
  const valueBN = BigInt(value);
  const millisatoshisBN = divisor ? valueBN * MILLISATS_PER_BTC / DIVISORS[divisor] : valueBN * MILLISATS_PER_BTC;
  if (divisor === "p" && !(valueBN % BigInt(10) === BigInt(0)) || millisatoshisBN > MAX_MILLISATS) {
    throw new Error("Amount is outside of valid range");
  }
  return outputString ? millisatoshisBN.toString() : millisatoshisBN;
}
function decode(paymentRequest, network) {
  if (typeof paymentRequest !== "string")
    throw new Error("Lightning Payment Request must be string");
  if (paymentRequest.slice(0, 2).toLowerCase() !== "ln")
    throw new Error("Not a proper lightning payment request");
  const sections = [];
  const decoded = bech32.decode(paymentRequest, Number.MAX_SAFE_INTEGER);
  paymentRequest = paymentRequest.toLowerCase();
  const prefix = decoded.prefix;
  let words = decoded.words;
  let letters = paymentRequest.slice(prefix.length + 1);
  let sigWords = words.slice(-104);
  words = words.slice(0, -104);
  let prefixMatches = prefix.match(/^ln(\S+?)(\d*)([a-zA-Z]?)$/);
  if (prefixMatches && !prefixMatches[2])
    prefixMatches = prefix.match(/^ln(\S+)$/);
  if (!prefixMatches) {
    throw new Error("Not a proper lightning payment request");
  }
  sections.push({
    name: "lightning_network",
    letters: "ln"
  });
  const bech32Prefix = prefixMatches[1];
  let coinNetwork;
  if (!network) {
    switch (bech32Prefix) {
      case DEFAULTNETWORK.bech32:
        coinNetwork = DEFAULTNETWORK;
        break;
      case TESTNETWORK.bech32:
        coinNetwork = TESTNETWORK;
        break;
      case SIGNETNETWORK.bech32:
        coinNetwork = SIGNETNETWORK;
        break;
      case REGTESTNETWORK.bech32:
        coinNetwork = REGTESTNETWORK;
        break;
      case SIMNETWORK.bech32:
        coinNetwork = SIMNETWORK;
        break;
    }
  } else {
    if (network.bech32 === void 0 || network.pubKeyHash === void 0 || network.scriptHash === void 0 || !Array.isArray(network.validWitnessVersions))
      throw new Error("Invalid network");
    coinNetwork = network;
  }
  if (!coinNetwork || coinNetwork.bech32 !== bech32Prefix) {
    throw new Error("Unknown coin bech32 prefix");
  }
  sections.push({
    name: "coin_network",
    letters: bech32Prefix,
    value: coinNetwork
  });
  const value = prefixMatches[2];
  let millisatoshis;
  if (value) {
    const divisor = prefixMatches[3];
    millisatoshis = hrpToMillisat(value + divisor, true);
    sections.push({
      name: "amount",
      letters: prefixMatches[2] + prefixMatches[3],
      value: millisatoshis
    });
  } else {
    millisatoshis = null;
  }
  sections.push({
    name: "separator",
    letters: "1"
  });
  const timestamp = wordsToIntBE(words.slice(0, 7));
  words = words.slice(7);
  sections.push({
    name: "timestamp",
    letters: letters.slice(0, 7),
    value: timestamp
  });
  letters = letters.slice(7);
  let tagName, parser, tagLength, tagWords;
  while (words.length > 0) {
    const tagCode = words[0].toString();
    tagName = TAGNAMES[tagCode] || "unknown_tag";
    parser = TAGPARSERS[tagCode] || getUnknownParser(tagCode);
    words = words.slice(1);
    tagLength = wordsToIntBE(words.slice(0, 2));
    words = words.slice(2);
    tagWords = words.slice(0, tagLength);
    words = words.slice(tagLength);
    sections.push({
      name: tagName,
      tag: letters[0],
      letters: letters.slice(0, 1 + 2 + tagLength),
      value: parser(tagWords)
      // see: parsers for more comments
    });
    letters = letters.slice(1 + 2 + tagLength);
  }
  sections.push({
    name: "signature",
    letters: letters.slice(0, 104),
    value: hex.encode(bech32.fromWordsUnsafe(sigWords))
  });
  letters = letters.slice(104);
  sections.push({
    name: "checksum",
    letters
  });
  let result = {
    paymentRequest,
    sections,
    get expiry() {
      let exp = sections.find((s) => s.name === "expiry");
      if (exp) return getValue("timestamp") + exp.value;
    },
    get route_hints() {
      return sections.filter((s) => s.name === "route_hint").map((s) => s.value);
    }
  };
  for (let name in TAGCODES) {
    if (name === "route_hint") {
      continue;
    }
    Object.defineProperty(result, name, {
      get() {
        return getValue(name);
      }
    });
  }
  return result;
  function getValue(name) {
    let section = sections.find((s) => s.name === name);
    return section ? section.value : void 0;
  }
}
var bolt11 = {
  decode,
  hrpToMillisat
};
const createPasteRuleMatch = (match, data) => ({ index: match.index, replaceWith: match[2], text: match[0], match, data });
function parseRelayAttribute(element) {
  const relays = element.getAttribute("relays") || [];
  return typeof relays === "string" ? relays.split(",") : relays;
}
const IMAGE_EXTENSIONS = /\.(jpg|jpeg|gif|png|bmp|svg|webp)$/;
const VIDEO_EXTENSIONS = /\.(webm|mp4|ogg|mov)$/;
const YOUTUBE_EMBED = /^(?:(?:https?:)?\/\/)?(?:(?:(?:www|m(?:usic)?)\.)?youtu(?:\.be|be\.com)\/(?:shorts\/|live\/|v\/|e(?:mbed)?\/|watch(?:\/|\?(?:\S+=\S+&)*v=)|oembed\?url=https?%3A\/\/(?:www|m(?:usic)?)\.youtube\.com\/watch\?(?:\S+=\S+&)*v%3D|attribution_link\?(?:\S+=\S+&)*u=(?:\/|%2F)watch(?:\?|%3F)v(?:=|%3D))?|www\.youtube-nocookie\.com\/embed\/)([\w-]{1})[?&#]?\S*$/;
const TWITTER_EMBED = /^https?:\/\/(twitter|x)\.com\/(?:#!\/)?(\w+)\/status(es)?\/(\d+)/;
function getLinkKind(url, imeta) {
  var _a, _b, _c, _d;
  const mimetype = (_d = (_c = (_b = (_a = imeta == null ? void 0 : imeta[url]) == null ? void 0 : _a.m) == null ? void 0 : _b.split) == null ? void 0 : _c.call(_b, "/")) == null ? void 0 : _d[0];
  if (mimetype === "image") {
    return "image";
  } else if (mimetype === "video") {
    return "video";
  } else if (YOUTUBE_EMBED.test(url)) {
    return "youtube";
  } else if (TWITTER_EMBED.test(url)) {
    return "tweet";
  } else {
    try {
      const { pathname } = new URL(url);
      return IMAGE_EXTENSIONS.test(pathname) ? "image" : VIDEO_EXTENSIONS.test(pathname) ? "video" : "text";
    } catch (error) {
      console.log("url parser error", error);
      return "text";
    }
  }
}
function replaceTextContent(content) {
  return content.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/(\n|\r)+/g, "<br />");
}
const LNBC_REGEX = new RegExp("(?<![\\w./:?=])(lnbc[0-9a-z]{10,})", "g");
const makeBolt11Attrs = (lnbc) => ({ bolt11: bolt11.decode(lnbc), lnbc });
const makeBolt11Node = (lnbc) => ({ type: "bolt11", attrs: makeBolt11Attrs(lnbc) });
const Bolt11Extension = Node.create({
  name: "bolt11",
  group: "block",
  atom: true,
  selectable: true,
  draggable: true,
  addAttributes() {
    return {
      lnbc: { default: null },
      bolt11: {
        default: null,
        renderHTML(attrs) {
          return { bolt11: JSON.stringify(attrs.bolt11 || {}) };
        },
        parseHTML(element) {
          const bolt112 = element.getAttribute("bolt11");
          return typeof bolt112 === "string" ? JSON.parse(bolt112 || "{}") : bolt112;
        }
      }
    };
  },
  addStorage() {
    return {
      markdown: {
        serialize(state, node) {
          state.write(node.attrs.lnbc);
        },
        parse: {}
      }
    };
  },
  addCommands() {
    return {
      insertBolt11: ({ lnbc }) => ({ commands }) => commands.insertContent(makeBolt11Node(lnbc), { updateSelection: false })
    };
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": this.name })];
  },
  renderText(props) {
    return props.node.attrs.lnbc;
  },
  parseHTML() {
    return [{ tag: `div[data-type="${this.name}"]` }];
  },
  addPasteRules() {
    return [
      nodePasteRule({
        type: this.type,
        getAttributes: (match) => match.data,
        find: (text) => {
          const matches = [];
          for (const match of text.matchAll(LNBC_REGEX)) {
            matches.push(createPasteRuleMatch(match, makeBolt11Attrs(match[0])));
          }
          return matches;
        }
      })
    ];
  }
});
async function uploadBlossom(options) {
  if (!options.hash) {
    throw new Error("No hash function provided");
  }
  if (!options.sign) {
    throw new Error("No signer provided");
  }
  const now = Math.floor(Date.now() / 1e3);
  const hash = await options.hash(options.file);
  const event = await options.sign({
    kind: 24242,
    content: `Upload ${options.file.name}`,
    created_at: now,
    tags: [
      ["u", options.serverUrl],
      ["method", "PUT"],
      ["t", "upload"],
      ["x", hash],
      ["size", options.file.size.toString()],
      ["expiration", Math.floor(now + (options.expiration || 6e4)).toString()]
    ]
  });
  const base64 = btoa(JSON.stringify(event));
  const authorization = `Nostr ${base64}`;
  const res = await fetch(options.serverUrl + "/upload", {
    method: "PUT",
    body: options.file,
    headers: {
      authorization
    }
  });
  if (res.status !== 200) {
    const reason = res.headers.get("X-Reason");
    throw new Error(reason || "Error on blossom upload");
  }
  const data = await res.json();
  const { nip94, ...json } = data;
  const { pathname } = new URL(json.url);
  const hasExtension = pathname.split(".").length === 2;
  const extension = "." + options.file.type.split("/")[1];
  const url = json.url + (hasExtension ? "" : extension);
  return {
    ...json,
    url,
    tags: Array.from(Object.entries(nip94 || [])).map((tag) => tag[0] === "url" ? [tag[0], url] : tag)
  };
}
async function uploadNIP96(options) {
  var _a, _b, _c, _d, _e, _f;
  if (!options.sign) {
    throw new Error("No signer provided");
  }
  const server = await readServerConfig(options.serverUrl);
  const authorization = await getToken(server.api_url, "POST", options.sign, true);
  const res = await uploadFile(options.file, server.api_url, authorization, {
    alt: options.alt || "",
    expiration: ((_a = options.expiration) == null ? void 0 : _a.toString()) || "",
    content_type: options.file.type
  });
  const url = ((_c = (_b = res.nip94_event) == null ? void 0 : _b.tags.find((x) => x[0] === "url")) == null ? void 0 : _c[1]) || "";
  const sha256 = ((_e = (_d = res.nip94_event) == null ? void 0 : _d.tags.find((x) => x[0] === "x")) == null ? void 0 : _e[1]) || "";
  return {
    url,
    sha256,
    tags: ((_f = res.nip94_event) == null ? void 0 : _f.tags) || []
  };
}
function bufferToHex(buffer) {
  return Array.from(new Uint8Array(buffer)).map((b) => b.toString(16).padStart(2, "0")).join("");
}
const FileUploadExtension = Extension.create({
  name: "fileUpload",
  addOptions() {
    return {
      allowedMimeTypes: ["image/jpeg", "image/png", "image/gif", "video/mp4", "video/mpeg", "video/webm"],
      immediateUpload: false,
      expiration: 6e4,
      async hash(file) {
        return bufferToHex(await crypto.subtle.digest("SHA-256", await file.arrayBuffer()));
      },
      onDrop() {
      },
      onStart() {
      },
      onUpload() {
      },
      onUploadError() {
      },
      onComplete() {
      }
    };
  },
  addCommands() {
    return {
      addFile: (file, pos) => (props) => {
        props.tr.setMeta("addFile", [file, pos]);
        return true;
      },
      selectFiles: () => (props) => {
        props.tr.setMeta("selectFiles", true);
        return true;
      },
      uploadFiles: () => (props) => {
        props.tr.setMeta("uploadFiles", true);
        return true;
      },
      removePendingUploads: () => (props) => {
        props.state.doc.descendants((node, pos) => {
          if (["image", "video"].includes(node.type.name) && node.attrs.uploading) {
            props.state.tr.delete(pos, pos + node.nodeSize);
          }
        });
        return true;
      },
      removeFailedUploads: () => (props) => {
        props.state.doc.descendants((node, pos) => {
          if (["image", "video"].includes(node.type.name) && node.attrs.uploadError) {
            props.state.tr.delete(pos, pos + node.nodeSize);
          }
        });
        return true;
      }
    };
  },
  addStorage() {
    return {
      uploader: null,
      getFiles: () => []
    };
  },
  onBeforeCreate() {
    const uploader = new Uploader(this.editor, this.options);
    this.storage.uploader = uploader;
    this.storage.getFiles = () => uploader.getFiles();
  },
  addProseMirrorPlugins() {
    const uploader = this.storage.uploader;
    return [
      new Plugin({
        key: new PluginKey("fileUploadPlugin"),
        state: {
          init: () => {
          },
          apply: (tr) => {
            setTimeout(async () => {
              if (tr.getMeta("addFile")) {
                const [file, pos] = tr.getMeta("addFile");
                uploader.addFile(file, pos);
                tr.setMeta("addFile", null);
                if (this.options.immediateUpload) {
                  uploader.start();
                }
              } else if (tr.getMeta("selectFiles")) {
                await uploader.selectFiles();
                tr.setMeta("selectFiles", null);
                if (this.options.immediateUpload) {
                  uploader.start();
                }
              } else if (tr.getMeta("uploadFiles")) {
                uploader.start();
                tr.setMeta("uploadFiles", null);
              }
            });
            return tr;
          }
        },
        props: {
          handleDrop: (_, event) => {
            uploader.handleDrop(event);
            if (this.options.immediateUpload) {
              uploader.start();
            }
          },
          handlePaste: (_, event) => {
            uploader.handlePaste(event);
            if (this.options.immediateUpload) {
              uploader.start();
            }
          }
        }
      })
    ];
  }
});
class Uploader {
  constructor(editor, options) {
    this.editor = editor;
    this.options = options;
  }
  get view() {
    return this.editor.view;
  }
  addFile(file, pos) {
    if (!this.options.allowedMimeTypes.includes(file.type)) {
      return false;
    }
    const { tr } = this.view.state;
    const [mimetype] = file.type.split("/");
    const node = this.view.state.schema.nodes[mimetype].create({
      file,
      src: URL.createObjectURL(file),
      alt: ""
    });
    tr.insert(pos, node);
    this.view.dispatch(tr);
    this.options.onDrop(this.editor, file, pos);
    return true;
  }
  getFiles() {
    return this.findNodes().map(([node]) => node.attrs);
  }
  findNodes(uploaded) {
    const nodes = [];
    this.view.state.doc.descendants((node, pos) => {
      if (!(node.type.name === "image" || node.type.name === "video")) {
        return;
      }
      if (uploaded !== void 0) {
        const isUploaded = !node.attrs.src.startsWith("blob:");
        if (isUploaded !== uploaded) {
          return;
        }
      }
      nodes.push([node, pos]);
    });
    return nodes;
  }
  updateNodeAttributes(pos, attrs) {
    const { tr } = this.view.state;
    Object.entries(attrs).forEach(([key, value]) => value !== void 0 && tr.setNodeAttribute(pos, key, value));
    this.view.dispatch(tr);
  }
  onUploadDone(nodeRef, response) {
    this.findNodes(false).forEach(([node, pos]) => {
      if (node.attrs.src === nodeRef.attrs.src) {
        this.updateNodeAttributes(pos, {
          ...response,
          src: encodeURI(response.url),
          uploading: false
        });
      }
    });
  }
  async upload(node, pos) {
    const { sign, hash, expiration } = this.options;
    const { file, alt, uploadType, uploadUrl: serverUrl } = node.attrs;
    this.updateNodeAttributes(pos, { uploading: true, uploadError: null });
    let res;
    try {
      res = uploadType === "nip96" ? await uploadNIP96({ file, alt, sign, serverUrl }) : await uploadBlossom({ file, serverUrl, hash, sign, expiration });
    } catch (error) {
      const msg = error == null ? void 0 : error.toString();
      res = { uploadError: msg, url: serverUrl };
    }
    this.onUploadDone(node, res);
    return res;
  }
  async start() {
    this.options.onStart(this.editor);
    const tasks = this.findNodes(false).map(([node, pos]) => {
      return this.upload(node, pos);
    });
    const errors = [];
    for await (const res of tasks) {
      if ("uploadError" in res) {
        errors.push(res.uploadError);
        this.options.onUploadError(this.editor, res);
      } else {
        this.options.onUpload(this.editor, res);
      }
    }
    if (errors.length === 0) {
      const files = this.getFiles();
      this.options.onComplete(this.editor, files);
      return files;
    }
    throw new Error(errors.join(","));
  }
  selectFiles() {
    return new Promise((resolve) => {
      const input = document.createElement("input");
      input.type = "file";
      input.multiple = true;
      input.accept = this.options.allowedMimeTypes.join(",");
      input.onchange = (event) => {
        const files = event.target.files;
        if (files) {
          Array.from(files).forEach((file) => {
            if (file) {
              const pos = this.view.state.selection.from + 1;
              this.addFile(file, pos);
            }
          });
        }
        resolve(files);
      };
      input.click();
    });
  }
  handleDrop(event) {
    var _a;
    event.preventDefault();
    const pos = (_a = this.view.posAtCoords({ left: event.clientX, top: event.clientY })) == null ? void 0 : _a.pos;
    if (!pos) return;
    if (!event.dataTransfer) return;
    for (const file of event.dataTransfer.files) {
      this.addFile(file, pos);
    }
  }
  handlePaste(event) {
    const data = event.clipboardData;
    if (data) {
      const items = data.items;
      let handled = false;
      for (let i = 0; i < items.length; i++) {
        const item = items[i];
        if (item.kind === "file" && this.options.allowedMimeTypes.includes(item.type)) {
          const file = item.getAsFile();
          if (file) {
            this.addFile(file, this.view.state.selection.from + 1);
            handled = true;
          }
        }
      }
      return handled;
    }
  }
}
const ImageExtension = Image.extend({
  draggable: true,
  addOptions() {
    return {
      inline: false,
      defaultUploadUrl: "https://nostr.build",
      defaultUploadType: "nip96"
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  addStorage() {
    return {
      markdown: {
        serialize: defaultMarkdownSerializer.nodes.image,
        parse: {}
      }
    };
  },
  addAttributes() {
    return {
      src: { default: null },
      alt: { default: null },
      file: { default: null },
      tags: { default: null },
      sha256: { default: null },
      uploading: { default: false },
      uploadError: { default: null },
      uploadType: { default: this.options.defaultUploadType },
      uploadUrl: { default: this.options.defaultUploadUrl }
    };
  },
  parseHTML() {
    return [{ tag: "img[src]" }];
  },
  renderText(props) {
    return props.node.attrs.src;
  },
  renderHTML({ HTMLAttributes }) {
    return ["img", HTMLAttributes];
  }
});
linkifyjs.registerCustomProtocol("wss");
const LinkExtension = Link.configure({ autolink: false }).extend({
  addPasteRules() {
    return [
      {
        find: (text) => {
          const matches = [];
          for (const { start, value, href } of linkifyjs.find(text.replace(/\ufffc/g, " "))) {
            matches.push({
              index: start,
              text: value,
              data: { href }
            });
          }
          return matches;
        },
        handler: (props) => {
          var _a;
          const { range, state, match } = props;
          const { from, to } = range;
          const { nodes, marks } = state.schema;
          const imeta = this.editor.storage.nostr.imeta;
          const url = (_a = match.data) == null ? void 0 : _a.href;
          const kind = getLinkKind(url, imeta);
          if (kind !== "text" && nodes[kind]) {
            state.tr.replaceWith(from, to, nodes[kind].create({ src: url }));
            return;
          }
          state.tr.addMark(from, to, marks.link.create({ href: url }));
        }
      }
    ];
  }
});
const getNip19Relays = (pointer, options) => {
  let relays = pointer.data.relays || [];
  if (options == null ? void 0 : options.getRelayHints) {
    relays = Array.from(/* @__PURE__ */ new Set([...relays, ...options.getRelayHints(pointer)]));
  }
  return relays;
};
const makeNAddrAttrs = (input, options) => {
  const bech322 = input.replace(/^nostr:/, "");
  const { type, data } = decode$1(bech322);
  const relays = getNip19Relays({ type, data }, options);
  switch (type) {
    case "naddr":
      return { type, bech32: bech322, relays, identifier: data.identifier, pubkey: data.pubkey, kind: data.kind };
    default:
      throw new Error(`Invalid nostr entity type for this context: ${type}`);
  }
};
const makeNAddrNode = (bech322, options) => ({
  type: "naddr",
  attrs: makeNAddrAttrs(bech322, options)
});
const NADDR_REGEX = new RegExp("(?<![\\w./:?=])(nostr:)?(naddr1[0-9a-z]+)", "g");
const NAddrExtension = Node.create({
  name: "naddr",
  group: "block",
  atom: true,
  selectable: true,
  draggable: true,
  priority: 1e3,
  addOptions() {
    return {
      getRelayHints: () => []
    };
  },
  addAttributes() {
    return {
      type: { default: null },
      bech32: { default: null },
      identifier: { default: null },
      pubkey: { default: null },
      kind: { default: null },
      relays: { default: [], parseHTML: parseRelayAttribute }
    };
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": this.name })];
  },
  renderText(props) {
    return "nostr:" + props.node.attrs.bech32;
  },
  parseHTML() {
    return [{ tag: `div[data-type="${this.name}"]` }];
  },
  addStorage() {
    return {
      markdown: {
        serialize(state, node) {
          state.write("nostr:" + node.attrs.bech32);
        },
        parse: {}
      }
    };
  },
  addCommands() {
    return {
      insertNAddr: ({ bech32: bech322 }) => ({ commands }) => commands.insertContent(makeNAddrNode(bech322, this.options), { updateSelection: false })
    };
  },
  addPasteRules() {
    return [
      nodePasteRule({
        type: this.type,
        getAttributes: (match) => match.data,
        find: (text) => {
          const matches = [];
          for (const match of text.matchAll(NADDR_REGEX)) {
            try {
              matches.push(createPasteRuleMatch(match, makeNAddrAttrs(match[2], this.options)));
            } catch (e) {
              continue;
            }
          }
          return matches;
        }
      })
    ];
  }
});
const makeNEventAttrs = (input, options) => {
  const bech322 = input.replace(/^nostr:/, "");
  const { type, data } = decode$1(bech322);
  const relays = getNip19Relays({ type, data }, options);
  switch (type) {
    case "note":
      return { type, bech32: bech322, relays, id: data };
    case "nevent":
      return { type, bech32: bech322, relays, id: data.id, kind: data.kind, author: data.author };
    default:
      throw new Error(`Invalid nostr entity type for this context: ${type}`);
  }
};
const makeNEventNode = (bech322, options) => ({
  type: "nevent",
  attrs: makeNEventAttrs(bech322, options)
});
const EVENT_REGEX = new RegExp("(?<![\\w./:?=])(nostr:)?(n(ote|event)1[0-9a-z]+)", "g");
const NEventExtension = Node.create({
  name: "nevent",
  group: "block",
  selectable: true,
  draggable: true,
  priority: 1e3,
  addOptions() {
    return {
      getRelayHints: () => []
    };
  },
  addAttributes() {
    return {
      type: { default: null },
      id: { default: null },
      kind: { default: null },
      author: { default: null },
      bech32: { default: null },
      relays: { default: [], parseHTML: parseRelayAttribute }
    };
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": this.name })];
  },
  renderText(props) {
    return "nostr:" + props.node.attrs.bech32;
  },
  parseHTML() {
    return [{ tag: `div[data-type="${this.name}"]` }];
  },
  addStorage() {
    return {
      markdown: {
        serialize(state, node) {
          state.write("nostr:" + node.attrs.bech32);
        },
        parse: {}
      }
    };
  },
  addCommands() {
    return {
      insertNEvent: ({ bech32: bech322 }) => ({ commands }) => commands.insertContent(makeNEventNode(bech322, this.options), { updateSelection: false })
    };
  },
  addPasteRules() {
    return [
      nodePasteRule({
        type: this.type,
        getAttributes: (match) => match.data,
        find: (text) => {
          const matches = [];
          for (const match of text.matchAll(EVENT_REGEX)) {
            try {
              matches.push(createPasteRuleMatch(match, makeNEventAttrs(match[2], this.options)));
            } catch (e) {
              continue;
            }
          }
          return matches;
        }
      })
    ];
  }
});
const YOUTUBE_REGEX = /^((?:https?:)?\/\/)?((?:www|m|music)\.)?((?:youtube\.com|youtu.be|youtube-nocookie\.com))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/;
const YOUTUBE_REGEX_GLOBAL = /^((?:https?:)?\/\/)?((?:www|m|music)\.)?((?:youtube\.com|youtu.be|youtube-nocookie\.com))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/g;
const isValidYoutubeUrl = (url) => {
  return url.match(YOUTUBE_REGEX);
};
const getYoutubeEmbedUrl = (nocookie) => {
  return nocookie ? "https://www.youtube-nocookie.com/embed/" : "https://www.youtube.com/embed/";
};
const getEmbedUrlFromYoutubeUrl = (options) => {
  const { url, allowFullscreen, autoplay, ccLanguage, ccLoadPolicy, controls, disableKBcontrols, enableIFrameApi, endTime, interfaceLanguage, ivLoadPolicy, loop, modestBranding, nocookie, origin, playlist, progressBarColor, startAt } = options;
  if (!isValidYoutubeUrl(url)) {
    return null;
  }
  if (url.includes("/embed/")) {
    return url;
  }
  if (url.includes("youtu.be")) {
    const id = url.split("/").pop();
    if (!id) {
      return null;
    }
    return `${getYoutubeEmbedUrl(nocookie)}${id}`;
  }
  const videoIdRegex = /(?:v=|shorts\/)([-\w]+)/gm;
  const matches = videoIdRegex.exec(url);
  if (!matches || !matches[1]) {
    return null;
  }
  let outputUrl = `${getYoutubeEmbedUrl(nocookie)}${matches[1]}`;
  const params = [];
  if (allowFullscreen === false) {
    params.push("fs=0");
  }
  if (autoplay) {
    params.push("autoplay=1");
  }
  if (ccLanguage) {
    params.push(`cc_lang_pref=${ccLanguage}`);
  }
  if (ccLoadPolicy) {
    params.push("cc_load_policy=1");
  }
  if (!controls) {
    params.push("controls=0");
  }
  if (disableKBcontrols) {
    params.push("disablekb=1");
  }
  if (enableIFrameApi) {
    params.push("enablejsapi=1");
  }
  if (endTime) {
    params.push(`end=${endTime}`);
  }
  if (interfaceLanguage) {
    params.push(`hl=${interfaceLanguage}`);
  }
  if (ivLoadPolicy) {
    params.push(`iv_load_policy=${ivLoadPolicy}`);
  }
  if (loop) {
    params.push("loop=1");
  }
  if (modestBranding) {
    params.push("modestbranding=1");
  }
  if (origin) {
    params.push(`origin=${origin}`);
  }
  if (playlist) {
    params.push(`playlist=${playlist}`);
  }
  if (startAt) {
    params.push(`start=${startAt}`);
  }
  if (progressBarColor) {
    params.push(`color=${progressBarColor}`);
  }
  if (params.length) {
    outputUrl += `?${params.join("&")}`;
  }
  return outputUrl;
};
const Youtube = Node.create({
  name: "youtube",
  addOptions() {
    return {
      addPasteHandler: true,
      allowFullscreen: true,
      autoplay: false,
      ccLanguage: void 0,
      ccLoadPolicy: void 0,
      controls: true,
      disableKBcontrols: false,
      enableIFrameApi: false,
      endTime: 0,
      height: 480,
      interfaceLanguage: void 0,
      ivLoadPolicy: 0,
      loop: false,
      modestBranding: false,
      HTMLAttributes: {},
      inline: false,
      nocookie: false,
      origin: "",
      playlist: "",
      progressBarColor: void 0,
      width: 640
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: true,
  addAttributes() {
    return {
      src: {
        default: null
      },
      start: {
        default: 0
      },
      width: {
        default: this.options.width
      },
      height: {
        default: this.options.height
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "div[data-youtube-video] iframe"
      }
    ];
  },
  addCommands() {
    return {
      setYoutubeVideo: (options) => ({ commands }) => {
        if (!isValidYoutubeUrl(options.src)) {
          return false;
        }
        return commands.insertContent({
          type: this.name,
          attrs: options
        });
      }
    };
  },
  addPasteRules() {
    if (!this.options.addPasteHandler) {
      return [];
    }
    return [
      nodePasteRule({
        find: YOUTUBE_REGEX_GLOBAL,
        type: this.type,
        getAttributes: (match) => {
          return { src: match.input };
        }
      })
    ];
  },
  renderHTML({ HTMLAttributes }) {
    const embedUrl = getEmbedUrlFromYoutubeUrl({
      url: HTMLAttributes.src,
      allowFullscreen: this.options.allowFullscreen,
      autoplay: this.options.autoplay,
      ccLanguage: this.options.ccLanguage,
      ccLoadPolicy: this.options.ccLoadPolicy,
      controls: this.options.controls,
      disableKBcontrols: this.options.disableKBcontrols,
      enableIFrameApi: this.options.enableIFrameApi,
      endTime: this.options.endTime,
      interfaceLanguage: this.options.interfaceLanguage,
      ivLoadPolicy: this.options.ivLoadPolicy,
      loop: this.options.loop,
      modestBranding: this.options.modestBranding,
      nocookie: this.options.nocookie,
      origin: this.options.origin,
      playlist: this.options.playlist,
      progressBarColor: this.options.progressBarColor,
      startAt: HTMLAttributes.start || 0
    });
    HTMLAttributes.src = embedUrl;
    return [
      "div",
      { "data-youtube-video": "" },
      [
        "iframe",
        mergeAttributes(this.options.HTMLAttributes, {
          width: this.options.width,
          height: this.options.height,
          allowfullscreen: this.options.allowFullscreen,
          autoplay: this.options.autoplay,
          ccLanguage: this.options.ccLanguage,
          ccLoadPolicy: this.options.ccLoadPolicy,
          disableKBcontrols: this.options.disableKBcontrols,
          enableIFrameApi: this.options.enableIFrameApi,
          endTime: this.options.endTime,
          interfaceLanguage: this.options.interfaceLanguage,
          ivLoadPolicy: this.options.ivLoadPolicy,
          loop: this.options.loop,
          modestBranding: this.options.modestBranding,
          origin: this.options.origin,
          playlist: this.options.playlist,
          progressBarColor: this.options.progressBarColor
        }, HTMLAttributes)
      ]
    ];
  }
});
const IMETA_RENAME = {
  bh: "blurhash"
};
function parseImeta(tags) {
  const metadata = {};
  for (const tag of tags) {
    if (tag[0] === "imeta") {
      let url;
      for (const [_key, value] of tag.map((x) => x.split(/ (.+)/))) {
        const key = IMETA_RENAME[_key] || _key;
        if (key === "url") {
          url = value;
          metadata[url] ?? (metadata[url] = {});
        }
        if (value && url) {
          switch (key) {
            case "fallback": {
              metadata[url].fallback = [...metadata[url].fallback || [], value];
              break;
            }
            case "dim": {
              const dimensions = value.split("x");
              metadata[url].dim = {
                width: parseInt(dimensions[0]),
                height: parseInt(dimensions[1])
              };
              break;
            }
            default: {
              metadata[url][key] = value;
              break;
            }
          }
        }
      }
    }
  }
  return metadata;
}
const makeNProfileAttrs = (input, options) => {
  const bech322 = input.replace(/^nostr:/, "");
  const { type, data } = decode$1(bech322);
  const relays = getNip19Relays({ type, data }, options);
  switch (type) {
    case "npub":
      return { type, bech32: bech322, relays, pubkey: data };
    case "nprofile":
      return { type, bech32: bech322, relays, pubkey: data.pubkey };
    default:
      throw new Error(`Invalid nostr entity type for this context: ${type}`);
  }
};
const makeNProfileNode = (bech322, options) => ({
  type: "nprofile",
  attrs: makeNProfileAttrs(bech322, options)
});
const PROFILE_REGEX = new RegExp("(?<![\\w./:?=])(nostr:)?(np(ub|rofile)1[0-9a-z]+)", "g");
const NProfileExtension = Node.create({
  name: "nprofile",
  atom: true,
  inline: true,
  group: "inline",
  priority: 1e3,
  addOptions() {
    return {
      getRelayHints: () => []
    };
  },
  addAttributes() {
    return {
      type: { default: null },
      bech32: { default: null },
      pubkey: { default: null },
      relays: { default: [], parseHTML: parseRelayAttribute }
    };
  },
  parseHTML() {
    return [{ tag: `span[data-type="${this.name}"]` }];
  },
  renderHTML({ HTMLAttributes }) {
    return ["span", mergeAttributes(HTMLAttributes, { "data-type": this.name }), "@"];
  },
  renderText(props) {
    return "nostr:" + props.node.attrs.bech32;
  },
  addStorage() {
    return {
      markdown: {
        serialize(state, node) {
          state.write("nostr:" + node.attrs.bech32);
        },
        parse: {}
      }
    };
  },
  addCommands() {
    return {
      insertNProfile: ({ bech32: bech322 }) => ({ commands }) => commands.insertContent(makeNProfileNode(bech322, this.options), { updateSelection: false })
    };
  },
  addPasteRules() {
    return [
      nodePasteRule({
        type: this.type,
        getAttributes: (match) => match.data,
        find: (text) => {
          const matches = [];
          for (const match of text.matchAll(PROFILE_REGEX)) {
            try {
              matches.push(createPasteRuleMatch(match, makeNProfileAttrs(match[2], this.options)));
            } catch (e) {
              continue;
            }
          }
          return matches;
        }
      })
    ];
  }
});
const NSEC_REGEX = /(nsec1[0-9a-z]+)/g;
const NSecRejectExtension = Extension.create({
  name: "nsecReject",
  addOptions() {
    return {};
  },
  addPasteRules() {
    return [
      {
        find: NSEC_REGEX,
        handler: (props) => {
          props.chain().deleteRange(props.range).insertContentAt(props.range.from, { text: "*NSEC_DELETED*", type: "text" }).run();
          if (this.options.onError) {
            this.options.onError(props);
            return;
          }
          window.alert("DO NOT PASTE YOUR NSEC INTO THE EDITOR");
        }
      }
    ];
  }
});
const REGEX_TAG_PASTE = new RegExp("(?<![\\w./:?=])(#[^\\W]+)", "g");
const REGEX_TAG_INPUT = new RegExp("(?<![\\w./:?=])(#[^\\W]+)$", "g");
const TagExtension = Mark.create({
  name: "tag",
  inline: true,
  selectable: true,
  inclusive: false,
  group: "inline",
  priority: 100,
  addStorage() {
    return {
      markdown: {
        serialize: {
          open: "",
          close: "",
          mixable: false,
          expelEnclosingWhitespace: true
        },
        parse: {}
      }
    };
  },
  renderHTML(p) {
    return ["a", mergeAttributes(p.HTMLAttributes, { "data-type": this.name })];
  },
  parseHTML() {
    return [{ tag: `a[data-type="${this.name}"]` }];
  },
  addAttributes() {
    return {
      tag: { default: null }
    };
  },
  addPasteRules() {
    return [
      markPasteRule({
        find: REGEX_TAG_PASTE,
        getAttributes: (match) => ({ tag: match[0] }),
        type: this.type
      })
    ];
  },
  addInputRules() {
    return [
      {
        find: (text) => {
          const match = text.match(REGEX_TAG_INPUT);
          if (match) {
            return {
              index: match.index,
              text: match[0],
              replaceWith: text,
              data: { tag: text },
              match
            };
          }
          return null;
        },
        handler: ({ state, range, match }) => {
          state.tr.delete(range.from, range.to).insertText(match[0]).addMark(range.from, range.to + 1, this.type.create({ tag: match[0] }));
        }
      }
    ];
  }
});
const TweetExtension = Node.create({
  name: "tweet",
  group: "block",
  selectable: true,
  draggable: true,
  addAttributes() {
    return {
      src: { default: null }
    };
  },
  addStorage() {
    return {
      markdown: {
        serialize(state, node) {
          state.write(node.attrs.src);
        },
        parse: {}
      }
    };
  },
  renderText(props) {
    return props.node.attrs.src;
  },
  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": this.name })];
  },
  parseHTML() {
    return [{ tag: `div[data-type="${this.name}"]` }];
  }
});
const VideoExtension = Node.create({
  name: "video",
  inline: false,
  group: "block",
  atom: true,
  selectable: true,
  draggable: true,
  addOptions() {
    return {
      defaultUploadUrl: "https://nostr.build",
      defaultUploadType: "nip96"
    };
  },
  addAttributes() {
    return {
      src: { default: null },
      alt: { default: null },
      file: { default: null },
      tags: { default: null },
      sha256: { default: null },
      uploading: { default: false },
      uploadError: { default: null },
      uploadType: { default: this.options.defaultUploadType },
      uploadUrl: { default: this.options.defaultUploadUrl }
    };
  },
  renderText(props) {
    return props.node.attrs.src;
  },
  renderHTML({ HTMLAttributes }) {
    return ["video", mergeAttributes(HTMLAttributes, { "data-type": this.name })];
  },
  parseHTML() {
    return [{ tag: "video" }];
  },
  addStorage() {
    return {
      markdown: {
        serialize: defaultMarkdownSerializer.nodes.image,
        parse: {}
      }
    };
  }
});
const NostrExtension = Extension.create({
  name: "nostr",
  addExtensions() {
    const { extend = {} } = this.options;
    const extensions = [];
    if (this.options.nprofile !== false) {
      extensions.push(NProfileExtension.extend(extend.nprofile));
    }
    if (this.options.nevent !== false) {
      extensions.push(NEventExtension.extend(extend.nevent));
    }
    if (this.options.naddr !== false) {
      extensions.push(NAddrExtension.extend(extend.naddr));
    }
    if (this.options.link !== false) {
      extensions.push(LinkExtension.extend(extend.link).configure(this.options.link));
    }
    if (this.options.tag !== false) {
      extensions.push(TagExtension.extend(extend.tag));
    }
    if (this.options.youtube !== false) {
      extensions.push(
        Youtube.extend({
          renderText: (p) => p.node.attrs.src,
          ...extend.youtube
        })
      );
    }
    if (this.options.image !== false) {
      extensions.push(ImageExtension.configure(this.options.image).extend(extend.image));
    }
    if (this.options.video !== false) {
      extensions.push(VideoExtension.configure(this.options.video).extend(extend.video));
    }
    if (this.options.tweet !== false) {
      extensions.push(TweetExtension.extend(extend.tweet));
    }
    if (this.options.bolt11 !== false) {
      extensions.push(Bolt11Extension.extend(extend.bolt11));
    }
    if (this.options.nsecReject !== false) {
      extensions.push(NSecRejectExtension);
    }
    if (this.options.fileUpload !== false) {
      extensions.push(FileUploadExtension.configure(this.options.fileUpload));
    }
    return extensions;
  },
  addStorage() {
    return {
      imeta: null,
      setImeta: () => {
      },
      getTags: () => [],
      getNaddrs: () => [],
      getNprofiles: () => [],
      getNevents: () => [],
      getPtags: () => [],
      getQtags: () => [],
      getAtags: () => [],
      getTtags: () => [],
      getImetaTags: () => [],
      getEditorTags: () => []
    };
  },
  onBeforeCreate() {
    this.storage.setImeta = (imeta) => {
      this.storage.imeta = imeta;
    };
    this.storage.getTags = () => {
      const tags = [];
      this.editor.state.doc.descendants((node) => {
        if (node.type.name === "text" && node.marks.length > 0) {
          node.marks.forEach((mark) => {
            if (mark.type.name === "tag") {
              tags.push(mark.attrs);
            }
          });
        }
      });
      return tags;
    };
    this.storage.getNprofiles = () => {
      const nprofiles = [];
      this.editor.state.doc.descendants((node) => {
        if (node.type.name === "nprofile") {
          nprofiles.push(node.attrs);
        }
      });
      return nprofiles;
    };
    this.storage.getNevents = () => {
      const nevents = [];
      this.editor.state.doc.descendants((node) => {
        if (node.type.name === "nevent") {
          nevents.push(node.attrs);
        }
      });
      return nevents;
    };
    this.storage.getNaddrs = () => {
      const naddress = [];
      this.editor.state.doc.descendants((node) => {
        if (node.type.name === "naddr") {
          naddress.push(node.attrs);
        }
      });
      return naddress;
    };
    this.storage.getTtags = () => {
      const tags = [];
      this.storage.getTags().forEach(({ tag }) => {
        const s = tag.slice(1).toLocaleLowerCase();
        if (!tags.some((t) => t[1] === s)) tags.push(["t", s]);
      });
      return tags;
    };
    this.storage.getPtags = (hints = true) => {
      return this.storage.getNprofiles().map(({ pubkey, relays }) => {
        const tag = ["p", pubkey];
        if (hints) {
          tag.push(relays[0] || "");
        }
        return tag;
      });
    };
    this.storage.getQtags = (hints = true) => {
      return this.storage.getNevents().map(({ id, author, relays }) => {
        const tag = ["q", id];
        if (hints) {
          tag.push(relays[0] || "");
          if (author) {
            tag.push(author);
          }
        }
        return tag;
      });
    };
    this.storage.getAtags = (hints = true) => {
      return this.storage.getNaddrs().map(({ kind, pubkey, identifier, relays }) => {
        const tag = ["a", `${kind}:${pubkey}:${identifier}`];
        if (hints) {
          tag.push(relays[0] || "");
        }
        return tag;
      });
    };
    this.storage.getImetaTags = () => {
      var _a;
      const uploader = (_a = this.editor.storage.fileUpload) == null ? void 0 : _a.uploader;
      return (uploader == null ? void 0 : uploader.getFiles().filter((x) => !!x.sha256).map((x) => {
        const meta = {
          url: x.src,
          x: x.sha256,
          m: x.file.type
        };
        for (const [k, v] of x.tags) {
          meta[k] = v;
        }
        return [
          "imeta",
          ...Object.entries(meta).map((kv) => kv.join(" ")).sort()
        ];
      })) || [];
    };
    this.storage.getEditorTags = (hints = true) => {
      return [
        ...this.storage.getPtags(hints),
        ...this.storage.getQtags(hints),
        ...this.storage.getAtags(hints),
        ...this.storage.getImetaTags(),
        ...this.storage.getTtags()
      ];
    };
  },
  addCommands() {
    return {
      setEventContent: (event, imeta) => (props) => {
        this.storage.setImeta(imeta || parseImeta(event.tags));
        props.chain().setMeta("parse", true).setMeta("uiEvent", "paste").setContent(event.kind === 1 ? replaceTextContent(event.content) : event.content);
        return true;
      },
      setEventContentKind0: (event) => (props) => {
        if (event.kind !== 0) {
          return false;
        }
        let content;
        try {
          content = JSON.parse(event.content);
        } catch (error) {
          return false;
        }
        if (content.about) {
          props.chain().setMeta("parse", true).setMeta("uiEvent", "paste").setContent(replaceTextContent(content.about));
        }
        return true;
      }
    };
  }
});
const isParagraphNode = (node) => node.type === "paragraph";
const isTextNode = (node) => node.type === "text";
const isHardBreak = (node) => node.type === "hardBreak";
const isHorizontalRule = (node) => node.type === "horizontalRule";
const isTagMark = (mark) => mark.type === "tag";
const isLinkMark = (mark) => mark.type === "link";
const isCodeMark = (mark) => mark.type === "code";
const isItalicMark = (mark) => mark.type === "italic";
const isBoldMark = (mark) => mark.type === "bold";
const isStrikeMark = (mark) => mark.type === "strike";
const isNProfileNode = (node) => node.type === "nprofile";
const isNEventNode = (node) => node.type === "nevent";
const isNAddrNode = (node) => node.type === "naddr";
const isImageNode = (node) => node.type === "image";
const isVideoNode = (node) => node.type === "video";
const isBolt11Node = (node) => node.type === "bolt11";
const isHeadingNode = (node) => node.type === "heading";
const isBulletListNode = (node) => node.type === "bulletList";
const isOrderedListNode = (node) => node.type === "orderedList";
const isCodeBlockNode = (node) => node.type === "codeBlock";
const isBlockQuoteNode = (node) => node.type === "blockquote";
const isTweetNode = (node) => node.type === "tweet";
const isYoutubeNode = (node) => node.type === "youtube";
export {
  Bolt11Extension,
  FileUploadExtension,
  ImageExtension,
  LinkExtension,
  NAddrExtension,
  NEventExtension,
  NProfileExtension,
  NSecRejectExtension,
  NostrExtension,
  TagExtension,
  TweetExtension,
  VideoExtension,
  isBlockQuoteNode,
  isBoldMark,
  isBolt11Node,
  isBulletListNode,
  isCodeBlockNode,
  isCodeMark,
  isHardBreak,
  isHeadingNode,
  isHorizontalRule,
  isImageNode,
  isItalicMark,
  isLinkMark,
  isNAddrNode,
  isNEventNode,
  isNProfileNode,
  isOrderedListNode,
  isParagraphNode,
  isStrikeMark,
  isTagMark,
  isTextNode,
  isTweetNode,
  isVideoNode,
  isYoutubeNode,
  makeBolt11Attrs,
  makeBolt11Node,
  makeNAddrAttrs,
  makeNAddrNode,
  makeNEventAttrs,
  makeNEventNode,
  makeNProfileAttrs,
  makeNProfileNode,
  uploadBlossom,
  uploadNIP96
};
//# sourceMappingURL=nostr-editor.js.map
